import React, { useContext } from "react";
import { TutorialModal } from "../tutorial-modal";
import { ASSOCIATE_PROFILE_DATA } from "../data/associate-profile-data";
import { store } from "../../Store";

/**
 * Wrapper del tutorial de asociar institución.
 * Su visibilidad depende del estado global `personalAccountTutorials.associateProfileVisible`.
 * @returns {JSX.Element}
 */
export const AssociateProfileTutorial = () => {
	const globalState = useContext(store);
	const visible = globalState?.state?.personalAccountTutorials?.associateProfileVisible;

	/**
	 * Actualiza el flag global de visibilidad del tutorial.
	 * @param {boolean} newVisible
	 */
	const setVisible = (newVisible) => {
		globalState.dispatch({
			type: "CHANGE",
			path: "personalAccountTutorials.associateProfileVisible",
			value: newVisible,
		});
	};

	/**
	 * Cierra el tutorial y apaga su flag global.
	 */
	const handleClose = () => {
		setVisible(false);
	};

	return (
		<TutorialModal
			visible={visible}
			setVisible={setVisible}
			onClose={handleClose}
			steps={ASSOCIATE_PROFILE_DATA}
			modalId="associate-profile-tutorial"
		/>
	);
};
